import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  inject,
  output,
} from '@angular/core';

/**
 * This directive is used to observe the width and height of an element.
 * If that height/ width changes, the directive will inform the parent component.
 * Practically this can be used to render different components based on the width/ height of an element.
 * Put simply it is similar to media queries but for elements/ components.
 */
@Directive({ selector: '[ag1ElementResize]' })
export class Ag1ElementResizeDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);

  private resizeObserver: ResizeObserver;

  readonly widthChange = output<number>();
  readonly heightChange = output<number>();

  constructor() {}

  ngOnInit(): void {
    this.resizeObserver = new ResizeObserver(
      (entries: ResizeObserverEntry[]) => {
        for (const entry of entries) {
          const width: number = entry.contentRect.width;
          this.widthChange.emit(width);

          const height: number = entry.contentRect.height;
          this.heightChange.emit(height);
        }
      },
    );

    this.resizeObserver?.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
